module.exports = __webpack_public_path__ + "assets/images/tootltip_description.8d364b84ddccfcd9d389da90a2204aca.png";